import { Injectable } from '@angular/core';

export interface QuickCompareLaunchPayload {
  primaryUrl: string;
  compareUrl: string;
  /** The competitor domain — set by inventory after all subscriptions settle. */
  compareDomain: string;
}

@Injectable({ providedIn: 'root' })
export class QuickCompareLaunchService {
  private pendingLaunch: QuickCompareLaunchPayload | null = null;

  setPendingLaunch(payload: QuickCompareLaunchPayload): void {
    this.pendingLaunch = payload;
  }

  consumePendingLaunch(): QuickCompareLaunchPayload | null {
    const launch = this.pendingLaunch;
    this.pendingLaunch = null;
    return launch;
  }
}

